// @flow
export { default } from './BannerToc';



// WEBPACK FOOTER //
// ./src/components/banner/BannerToc/index.js